export enum WidgetActionMethod {
  Init = 'init',
  Destroy = 'destroy',
  ExtendContext = 'extendContext',
  Subscribe = 'subscribe',
  ExtendTrackingParameters = 'extendTrackingParameters',
  SetLanguage = 'setLanguage',
}
